import React, { useEffect, useState } from "react";
import userdashboardlogo from "../../images/user-dashboard-logo.svg";
import googleplaylogo from "../../images/googleplay.svg";
import appstorelogo from "../../images/appstore.svg";
import homebottombg from "../../images/home-bottom-bg.gif";
import homrbg from "../../images/home-bg-video.mp4";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import { callApi } from "./API/Api";
import { showProcessToast, updateToastMessage } from "../common/Tostify";
import { getBaseUrl } from "./BaseUrl";
const Footer = () => {
  const [contactspagedata, setContactspagedata] = useState();
  const [validmeg, setValidmeg] = useState("");
  const [email, setEmial] = useState("");
  const { t } = useTranslation();
  let base_url = getBaseUrl();
  const settings = {
    centerMode: true,
    slidesToShow: 1,
    autoplay: false,
    centerPadding: "0px",
    autoplaySpeed: 4000,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 1,
        },
      },
    ],
  };
  const style = {
    position: "absolute",
    right: "-100px",
    bottom: "-80px",
    backgroundImage: `url(${homebottombg})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "bottom right",
    paddingBottom: "0px",
    backgroundSize: "100%",
    width: "560px",
    height: "800px",
    transform: "rotate(26deg)",
  };
 
  const aboutpagecontent = async () => {
    try {
      let langcode = base_url.split("/")[1]
      let postdata = {};
      let res = await callApi(
        postdata,
        `api/get-contact-us-page?lang=${langcode}`,
        "GET",
      );
      if (res?.data?.success) {
        setContactspagedata({ ...res?.data?.data, ...res?.data?.contact_data });
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    aboutpagecontent();
  }, [base_url]);
  const BreakText = ({ text, breakAt }) => {
    const splitText = (text, breakAt) => {
      if (!text) return;
      const words = text?.split(" ");
      const beforeBreak = words.slice(0, breakAt)?.join(" ");
      const afterBreak = words.slice(breakAt)?.join(" ");
      return (
        <>
          {beforeBreak}
          <br />
          {afterBreak}
        </>
      );
    };

    return splitText(text, breakAt);
  };
  const subscribe = async (email) => {
    try {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email) {
        setValidmeg("Email is Required");
        return;
      } else if (!emailRegex.test(email)) {
        setValidmeg("Please enter a valid email address.");
        return;
      }
      setValidmeg("");
      const processToastId = showProcessToast("Loading data... Please wait.");
      let postdata = {
        email: email,
      };
      let res = await callApi(postdata, `api/add-subscriber`, "POST");
      if (res?.data?.success) {
        setValidmeg("");
        updateToastMessage(processToastId, res?.data?.message, "success");
        setEmial("");
      } else {
        updateToastMessage(
          processToastId,
          res?.error?.error?.email[0],
          "error",
        );
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  // highlight-code

  const [highlight, setHighlight] = useState(false);
  useEffect(() => {
    const handleHighlight = () => {
      setHighlight(true);

      // setTimeout(() => {
      //   setHighlight(false);
      // }, 10000);
    };

    window.addEventListener("highlight-contact", handleHighlight);

    return () => {
      window.removeEventListener("highlight-contact", handleHighlight);
    };
  }, []);

const handleClick = (e) => {
  const isTouchDevice =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;

  const url = e.currentTarget.href;

  if (isTouchDevice) {
    e.preventDefault();

    setTimeout(() => {
      window.location.href = url;
    }, 1000);
  }
};
  return (
    <React.Fragment>
      <footer className="footer-area">
        <div className="container carousel-container">
          <div className="footer-top">
            <div className="row centerFooter">
              <div className="col-xl-5 col-lg-5 col-md-6 col-sm-6">
                <div className="subscribe_box">
                  <div className="site_logo">
                    <Link to={`${base_url}`}>
                      <img src={userdashboardlogo} alt="" />
                    </Link>
                  </div>
                  <h4 className="footer-title">{t("Subscribe")}</h4>
                  <form action="#">
                    <div className="form-group">
                      <input
                        style={{ color: "#fff" }}
                        onChange={(e) => setEmial(e.target.value)}
                        value={email}
                        type="email"
                        name="email"
                        placeholder="Email address"
                        className="form-control"
                      />
                      <div
                        type="submit"
                        className="btn site_grdbtn"
                        onClick={() => subscribe(email)}
                      >
                        {t("Submit")}
                      </div>
                    </div>
                    {validmeg && <p className="text-danger">{validmeg}</p>}
                    <p className="mb-0">
                      {t(
                        "Hello, we are Lift Media. Our goal is to translate the positive effects from revolutionizing how",
                      )}
                    </p>
                  </form>
                  
                  <div className="app_storelogo">
                    <a href={`${base_url}instruction-android`}
                      onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}>
                      <img src={googleplaylogo} alt="" />
                    </a>
                    <a href={`${base_url}instruction-ios`}
                      onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}>
                      <img src={appstorelogo} alt="" />
                    </a>
                  </div>

                </div>
              </div>
              <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-6">
                <h4 className="footer-title">{t("Quick Links")}</h4>
                <ul className="footer_menu_links">
                  <li>
                    <Link to={`${base_url}`}>{t("Home")}</Link>
                  </li>
                  <li>
                    <Link to="" onClick={(e) => e.preventDefault()}>
                      {t("Trading")}
                    </Link>
                  </li>
                  <li>
                    <Link to="" onClick={(e) => e.preventDefault()}>
                      {t("Education")}
                    </Link>
                  </li>
                  <li>
                    <a
                      href="mailto:support@equlix.com"
                      // onClick={(e) => {
                      //   e.preventDefault();
                      // }}
                    >
                      {t("Support")}
                    </a>
                  </li>
                  {/* <li>
                    <Link to="" onClick={(e) => e.preventDefault()}>
                      {t("More")}
                    </Link>
                  </li> */}
                </ul>
              </div>
              <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-6">
                <h4 className="footer-title">{t("Resources")}</h4>
                <ul className="footer_menu_links">
                  <li>
                    <Link to="" onClick={(e) => e.preventDefault()}>
                      {t("Trading Academy")}
                    </Link>
                  </li>
                  <li>
                    <Link to="" onClick={(e) => e.preventDefault()}>
                      {t("Tutorials")}
                    </Link>
                  </li>
                  <li>
                    <Link to="" onClick={(e) => e.preventDefault()}>
                      {t("Webinars")}
                    </Link>
                  </li>
                  <li>
                    <Link to="" onClick={(e) => e.preventDefault()}>
                      {t("Market Insights")}
                    </Link>
                  </li>
                  <li>
                    <a href={`https://equlixpartner.com/`}>{t("Affiliate")}</a>
                  </li>
                </ul>
              </div>
              <div
                className="col-xl-3 col-lg-3 col-md-6 col-sm-6"
                id="get-in-touch"
              >
                <h4 className="footer-title">{t("Get in Touch")}</h4>
                <ul className="footer_menu_links contactDtl">
                  {/* <li>{contactspagedata?.content?.email}</li> */}
                  <li className={highlight ? "highlight" : "not"}>
                    {contactspagedata?.content?.email}
                  </li>
                  <li>Contact us on   <div
  dangerouslySetInnerHTML={{
    __html: contactspagedata?.content?.phone?.replace(
      /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
      '<a href="mailto:$1">$1</a>'
    ),
  }}
/></li>
                  <li>
                    <BreakText
                      text={contactspagedata?.content?.address}
                      breakAt={2}
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="copy-right-area">
            <div className="row">
              <div className="col-12">
                <div className="copy-right-content">
                  <p>
                    © {new Date().getFullYear()}. {t("All rights reserved")}
                  </p>
                  {/* <div className="social-link mousescreen_social">
                    <Link to="https://t.me/EqulixOfficial" target="_blank" className="telegram-icon">
                      <div className="i-icon"><i class="fa-brands fa-telegram"></i></div>
                      <span className="hoverSocial telegram-t">Telegram</span>
                    </Link>
                    <Link to="https://www.instagram.com/equlixofficial?igsh=MTgzNTJpMHBxYjhscA==" target="_blank" className="instagram-icon">
                      <div className="i-icon"><i className="fa-brands fa-instagram"></i></div>
                      <span className="hoverSocial instagram-t">Instagram</span>
                    </Link> 
                    <Link to="https://x.com/EqulixOfficial" target="_blank" className="twitter-icon">
                      <div className="i-icon"><i className="fa-brands fa-x-twitter"></i></div>
                      <span className="hoverSocial twitter-t">Twitter</span>
                    </Link>
                    <Link to="https://vk.com/equlix" target="_blank" className="vk-icon">
                      <div className="i-icon"><i class="fa-brands fa-vk"></i></div>
                      <span className="hoverSocial vk-t">Vk</span>
                    </Link>
                  </div> */}

                  <div className="social-link tuchscreen_social">
                    <Link to="https://t.me/EqulixOfficial" target="_blank" className="telegram-icon" onClick={handleClick}>
                      <div className="i-icon"><i class="fa-brands fa-telegram"></i></div>
                      <span className="hoverSocial telegram-t">Telegram</span>
                    </Link>
                    <Link to="https://www.instagram.com/equlixofficial?igsh=MTgzNTJpMHBxYjhscA==" target="_blank" onClick={handleClick} className="instagram-icon">
                      <div className="i-icon"><i className="fa-brands fa-instagram"></i></div>
                      <span className="hoverSocial instagram-t">Instagram</span>
                    </Link> 
                    <Link to="https://x.com/EqulixOfficial" target="_blank" className="twitter-icon" onClick={handleClick}>
                      <div className="i-icon"><i className="fa-brands fa-x-twitter"></i></div>
                      <span className="hoverSocial twitter-t">Twitter</span>
                    </Link>
                    <Link to="https://vk.com/equlix" target="_blank" className="vk-icon" onClick={handleClick}>
                      <div className="i-icon"><i class="fa-brands fa-vk"></i></div>
                      <span className="hoverSocial vk-t">Vk</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
